<template>
  <b-skeleton-wrapper :loading="isLoading">
    <template #loading>
      <b-row>
        <b-col v-for="n in 3" :key="n">
          <b-skeleton width="75%" />
          <b-skeleton width="50%" />
        </b-col>
      </b-row>
    </template>
    <ReadOnly :items="items" />
  </b-skeleton-wrapper>
</template>

<script>
import ReadOnly from './index'
import {
  originAddressReadOnly,
  destinationAddressReadOnly,
} from '../../lib/constants/read-only-items'
import get from 'lodash/get'

export default {
  components: {
    ReadOnly,
  },
  inject: ['isLoading'],
  props: {
    showResponse: {
      type: Object,
    },
    type: {
      type: String,
      default: 'parent_origin_address',
    },
  },
  computed: {
    baseItems() {
      if (this.type === 'parent_destination_address') {
        return destinationAddressReadOnly(this.$t.bind(this))
      }

      return originAddressReadOnly(this.$t.bind(this))
    },
    items() {
      const source = get(this.showResponse, this.type, {})

      return this.baseItems.map((item) => ({
        ...item,
        value: item.format ? item.format(source) : (get(source, item.key) || '-'),
      }))
    },
  },
}
</script>
